import { gql } from "lib/apolloClient";

export const curriculumProgramFragment = {
  subscriptionPlanDetails: gql`
    fragment subscriptionPlanDetailsItem on CurriculumProgram {
      id
      type
      subscriptionPlan {
        id
        type
        isFree
        label
      }
    }
  `,
};

export const curriculumFragment = {
  curriculum: gql`
    fragment curriculumItem on Curriculum {
      id
      label
      type
    }
  `,
};

export const academicYearTransitionConfigurationStateFragment = {
  academicYearTransitionConfigurationState: gql`
    fragment academicYearTransitionConfigurationStateItem on AcademicYearTransitionProgrammeConfigurationState {
      state
      isComplete
      isChecked
      updatedAt
      updatedBy {
        id
        email
      }
    }
  `,
};

export const organizationFragment = {
  curriculumPrograms: gql`
    fragment curriculumProgramsItem on Organization {
      id
      curriculumPrograms {
        id
        label
        acronym
        entityCount(input: $entityFilters) {
          entityType
          count
          __typename
        }
        curriculum {
          ...curriculumItem
        }
        ...subscriptionPlanDetailsItem
        academicYearTransitionConfigurationState(
          filters: { academicYearId: $academicYearId }
        ) {
          ...academicYearTransitionConfigurationStateItem
        }
      }
    }
    ${curriculumProgramFragment.subscriptionPlanDetails}
    ${curriculumFragment.curriculum}
    ${academicYearTransitionConfigurationStateFragment.academicYearTransitionConfigurationState}
  `,
};
